var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurgery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.234,
    height: 20.929,
    viewBox: "0 0 21.234 20.929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-surgery-599",
    transform: "translate(-0.009 -8.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27657",
    "data-name": "Path 27657",
    d: "M.815,9.384A.139.139,0,0,1,.87,9.2l1.013-.552a.138.138,0,0,1,.189.056l.406.741A3.467,3.467,0,0,1,6.513,11.1L4.551,12.169A1.227,1.227,0,0,1,2.4,13.344L.433,14.414a3.459,3.459,0,0,1,.788-4.288Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27658",
    "data-name": "Path 27658",
    d: "M826.82,805.61h6.6v6.826h-6.6Z",
    transform: "translate(-812.181 -782.881)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27659",
    "data-name": "Path 27659",
    d: "M394.376,811.364h-5.333a1.685,1.685,0,1,1,0-3.37h5.333Z",
    transform: "translate(-380.494 -785.223)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27660",
    "data-name": "Path 27660",
    d: "M134.235,1037.789a.683.683,0,0,1,.682-.683h10.816v2.73h-11.5Z",
    transform: "translate(-131.851 -1010.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27661",
    "data-name": "Path 27661",
    d: "M139.834,770.584a2.037,2.037,0,1,1-2.037-2.034,2.036,2.036,0,0,1,2.037,2.034",
    transform: "translate(-133.349 -746.477)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27662",
    "data-name": "Path 27662",
    d: "M365.588,319.7l-1.146-3.262c-.222-.615-.649-1.1-1.854-1.1H357.3c-1.2,0-1.632.48-1.853,1.1L354.3,319.7a.829.829,0,0,0,.336,1l2.694,1.775a.853.853,0,1,0,.939-1.423l-1.294-.853-.843-.556.6-1.66h.833l-.488,1.347,1.623,1.07a1.637,1.637,0,0,1,.465,2.266,1.648,1.648,0,0,1-.346.375h2.247a1.673,1.673,0,0,1-.347-.375,1.636,1.636,0,0,1,.465-2.266l1.624-1.07-.49-1.347h.834l.6,1.66-.844.556-1.3.853a.853.853,0,1,0,.941,1.423l2.693-1.775a.831.831,0,0,0,.337-1Z",
    transform: "translate(-347.968 -301.293)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27663",
    "data-name": "Path 27663",
    d: "M540.748,134.9a.806.806,0,0,1-1.464,0h-1.475a2.193,2.193,0,0,0-.038.4,2.254,2.254,0,1,0,4.471-.4Z",
    transform: "translate(-528.246 -124.039)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27664",
    "data-name": "Path 27664",
    d: "M550.5,31.505a.806.806,0,0,1,1.563,0h1.279a2.253,2.253,0,0,0-4.1,0Z",
    transform: "translate(-539.513 -21.176)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurgery);
export default __webpack_public_path__ + "static/media/surgery.776c3a07ea84fb168e378294be12c38d.svg";
export { ForwardRef as ReactComponent };